/**
 * inverse of v-cloak
 */
export default {
    update(el) {
        if (el.parentNode) {
            el.parentNode.removeChild(el);
        }
    },
}
